import { useMutation } from '@tanstack/react-query';
import uploadsApiClient, { UploadFileInput } from '../../api/uploads';

const useUploadAlarmMutation = () => {
  return useMutation({
    mutationFn: (input: UploadFileInput) => uploadsApiClient.uploadAlarm(input),
  });
};

export default useUploadAlarmMutation;
